import MuiMenu from '@material-ui/core/Menu';

export default MuiMenu;
